//#region IMPORTS
import cEntity from '../api/collectingEntity.service';

//#endregion IMPORTS

//#region CONSTANTS

const initialData = {
    cEntities: [],
    cEntityAdd: null,
    cEntityError: '',
    totalRows: 0
}
//#endregion CONSTANTS

//#region TYPES

const LOAD_COLLECTING_ENTITIES = 'LOAD_COLLECTING_ENTITIES';
const ADD_COLLECTING_ENTITY = 'ADD_COLLECTING_ENTITY';
const ERROR_COLLECTING_ENTITY = 'ERROR_COLLECTING_ENTITY';
const ENTITY_COUNT = 'ENTITY_COUNT';
//#endregion TYPES

//#region REDUCER

export default function collectingEntityReducer(state = initialData, action) {
    switch (action.type) {
        case LOAD_COLLECTING_ENTITIES:
            return { ...state, cEntities: action.payload };
        case ADD_COLLECTING_ENTITY:
            return { ...state, cEntityAdd: action.payload };
        case ERROR_COLLECTING_ENTITY:
            return { ...state, cEntityError: action.payload };
        case ENTITY_COUNT:
            return { ...state, totalRows: action.payload };
        default:
            return { ...state };
    }
}
//#endregion REDUCER

//#region ACTIONS

export const findAll = (username, country, page, length) => async (dispatch) => {
    const response = await cEntity.getAllEntities(username, country, page, length).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: response
        });
        dispatch({
            type: LOAD_COLLECTING_ENTITIES,
            payload: []
        });
    } else {
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: ''
        });
        dispatch({
            type: LOAD_COLLECTING_ENTITIES,
            payload: response
        });
    }


    return response;
}

export const findBySocieties = (society) => async (dispatch) => {
    
    const response = await cEntity.findBySociety(society, 0).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    
    let data = [];
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: response
        });
        dispatch({
            type: LOAD_COLLECTING_ENTITIES,
            payload: []
        });
    } else {
        response.forEach((element) => {
            data.push({
                value: element.entityId,
                label: element.name.toUpperCase()+' | '+element.code,
            });
        });
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: ''
        });
        dispatch({
            type: LOAD_COLLECTING_ENTITIES,
            payload: data
        });
    }

}
export const countPageByFilter = (country) => async (dispatch) => {

    const response = await cEntity.getcountByCountry(country).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: response
        });
        dispatch({
            type: ENTITY_COUNT,
            payload: 0
        });
    } else {

        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: ''
        });
        dispatch({
            type: ENTITY_COUNT,
            payload: response
        });
    }

}

export const saveEntity = (cEntityData, username) => async (dispatch) => {
    const response = await cEntity.saveEntity(cEntityData, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });

    if (response.error !== undefined) {
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: response
        });
        dispatch({
            type: ADD_COLLECTING_ENTITY,
            payload: ''
        });
    } else {
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: ''
        });
        dispatch({
            type: ADD_COLLECTING_ENTITY,
            payload: response
        });
    }


    return response;
}

export const deleteEntity = (lsCEntities, username) => async (dispatch) => {
    const response = await cEntity.deleteEntity(lsCEntities, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });

    if (response.error !== undefined) {
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: response
        });
        dispatch({
            type: ADD_COLLECTING_ENTITY,
            payload: ''
        });
    } else {
        dispatch({
            type: ERROR_COLLECTING_ENTITY,
            payload: ''
        });
        dispatch({
            type: ADD_COLLECTING_ENTITY,
            payload: { delete: true, name: 'delete', data: response }
        });
    }

}
//#endregion ACTIONS
